import materialIconsWoff2Url from 'material-design-icons-iconfont/dist/fonts/MaterialIcons-Regular.woff2?url';
import materialIconsWoffUrl from 'material-design-icons-iconfont/dist/fonts/MaterialIcons-Regular.woff?url';
import { log } from './vueLogger';

let preloadPromise = null;

export function preloadMaterialIconsFont() {
	if (preloadPromise) {
		return preloadPromise;
	}

	preloadPromise = (async () => {
		if (typeof window === 'undefined' || typeof document === 'undefined' || typeof FontFace === 'undefined' || !document.fonts) {
			return;
		}

		if (document.fonts.check('24px "Material Icons"')) {
			return;
		}

		const materialIconsFont = new FontFace('Material Icons', `url(${materialIconsWoff2Url}) format("woff2"), url(${materialIconsWoffUrl}) format("woff")`, {
			style: 'normal',
			weight: '400',
			display: 'block',
		});

		await materialIconsFont.load();
		document.fonts.add(materialIconsFont);
		log('info', 'MaterialIcons', 'Material Icons font preloaded');
	})().catch((error) => {
		log('warn', 'MaterialIcons', `Material Icons preload failed: ${error.message}`);
	});

	return preloadPromise;
}
